module.exports = __webpack_public_path__ + "img/logo_inmyout.679319c1.png";